import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  AUDIT_RESULTS_CLEAR,
  AUDIT_RESULTS_CLEAR_RESULTS,
  AUDIT_RESULTS_FETCH_COMPLETED_AUDIT_REQUEST,
  AUDIT_RESULTS_FETCH_INCIDENTS_COMPARISON,
  AUDIT_RESULTS_SAVE_ASSET_AUDIT_REQUEST,
} from '../../../../actions/actionTypes';

const incidentsComparison = fetchReducerGenerator(
  [
    AUDIT_RESULTS_CLEAR,
    AUDIT_RESULTS_CLEAR_RESULTS,
    AUDIT_RESULTS_FETCH_COMPLETED_AUDIT_REQUEST,
    AUDIT_RESULTS_SAVE_ASSET_AUDIT_REQUEST,
  ],
  AUDIT_RESULTS_FETCH_INCIDENTS_COMPARISON
);

export default incidentsComparison;
